import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-file-service",
  "use": "app-icon-file-service-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app-icon-file-service\"><path d=\"M20.72 9.61V6.36h-8.88l-3.12-2.8H3.56v6l17.16.05zm0 1.56H3.56v9.27h17.16v-9.27zM9.32 2l3.12 2.8h8.84a1 1 0 011 1V21a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1h6.32z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol